import { Metamodel } from 'app/model/base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { InformixTableDataset } from 'app/model/dataset/informix-table.dataset';
import { TabularCopySink } from './tabular.copysink';

@Metamodel.model({
    name: adfModelTypeMap.informix.copySinkType,
    display: [],
    tags: {
        datasetModel: [
            Metamodel.modelFor(InformixTableDataset)
        ]
    }
})
export class InformixCopySink extends TabularCopySink {
}
